// Importar los pages
// Este archivo de rutas, debe ser dinámico e incremental

import Layout from "../../layouts/Layout";
import Home from "../../pages/home/Home";
import Page2 from "../../pages/page2/Page2";
import QuienesSomos from "../../pages/quienes-somos/QuienesSomos";
import EdificioCorporativo from "../../pages/edificio-corporativo/EdificioCorporativo";
import PublicidadHistoria from "../../pages/publicidad-historia/PublicidadHistoria";
import ArchivoPatrimonial from "../../pages/archivo-patrimonial/ArchivoPatrimonial";
import PionerosEnergia from "../../pages/pioneros-energia/PionerosEnergia";

const siteName: string = 'Fundación Gasco';

const routesPages = [

    {
        path: '/',
        title:  `${siteName} | Desde el 2001 promoviendo el arte, la educación y el patrimonio`,
        breadTitle: 'Inicio',
        layout: Layout,
        component: Home,
      },
      {
        path: '/quienes-somos',
        title: `Quiénes Somos | ${siteName}`,
        breadTitle: 'Quiénes Somos',
        layout: Layout,
        component: QuienesSomos,
      },
      {
        path: '/edificio-corporativo',
        title: `Edificio Corporativo | ${siteName}`,
        breadTitle: 'Edificio Corporativo',
        layout: Layout,
        component: EdificioCorporativo,
      },
      {
        path: '/publicidad-para-una-historia',
        title: `Publicidad para una Historia | ${siteName}`,
        breadTitle: 'Publicidad para una Historia',
        layout: Layout,
        component: PublicidadHistoria,
      },
      {
        path: '/pioneros-de-la-energia',
        title: `Pioneros de la Energía | ${siteName}`,
        breadTitle: 'Pioneros de la Energía',
        layout: Layout,
        component: PionerosEnergia,
      },
      {
        path: '/archivo-patrimonial',
        title: `Archivo Patrimonial | ${siteName}`,
        breadTitle: 'Archivo Patrimonial',
        layout: Layout,
        component: ArchivoPatrimonial,
      },
      {
        path: '/page2',
        title: siteName,
        breadTitle: 'Página 2',
        layout: Layout,
        component: Page2,
      }
];

export default routesPages;

